import * as React from "react";
import { getBrowserInfo, GPay_TransactionState } from "@grandvisionhq/payments";
import { useHandleOrderCreation } from "./useHandlerOrderCreation.js";
import { useValidateAndSetOrderDetails } from "./useValidateAndSetOrderDetails.js";
const useHandleGpayConfig = ({
  selectedPaymentMethod,
  selfUrl,
  donationInfo,
  consents,
  selectedShippingMethod,
  isSaveDetailsInAccount = false,
  setIsOrderInProgress
}) => {
  const { saveCustomerInformation } = useValidateAndSetOrderDetails();
  const { handlePlaceOrder } = useHandleOrderCreation();
  const consentsRef = React.useRef(consents);
  React.useEffect(() => {
    consentsRef.current = consents;
  }, [consents]);
  const createGooglePayOrder = React.useCallback(
    (googlePayToken) => {
      setIsOrderInProgress(true);
      selectedPaymentMethod?.type && handlePlaceOrder({
        selectedPaymentMethod,
        paymentDetails: {
          isValid: true,
          type: selectedPaymentMethod?.type,
          data: { googlePayToken, browserInfo: { ...getBrowserInfo() } }
        },
        selfUrl,
        consents: consentsRef.current,
        donationInfo,
        isSaveDetailsInAccount,
        setIsOrderInProgress
      });
    },
    [
      donationInfo,
      handlePlaceOrder,
      isSaveDetailsInAccount,
      selectedPaymentMethod,
      selfUrl,
      setIsOrderInProgress
    ]
  );
  const onGpayAuthorized = React.useCallback(
    (gpay_payment_details) => {
      createGooglePayOrder(gpay_payment_details.paymentMethodData.tokenizationData.token);
    },
    [createGooglePayOrder]
  );
  const handleGpayCtaClick = React.useCallback(
    async (resolve, reject) => {
      return await saveCustomerInformation(selectedShippingMethod, consentsRef.current).then(({ success }) => {
        return success ? resolve({ transactionState: GPay_TransactionState.SUCCESS }) : reject({ transactionState: GPay_TransactionState.ERROR });
      }).catch(() => {
        return reject({ transactionState: GPay_TransactionState.ERROR });
      });
    },
    [saveCustomerInformation, selectedShippingMethod]
  );
  return {
    handleGpayCtaClick,
    onGpayAuthorized
  };
};
export {
  useHandleGpayConfig
};
//# sourceMappingURL=useHandleGpayConfig.js.map
